import { render, staticRenderFns } from "./testMemberNavi.vue?vue&type=template&id=48eaf041&scoped=true&"
import script from "./testMemberNavi.vue?vue&type=script&lang=js&"
export * from "./testMemberNavi.vue?vue&type=script&lang=js&"
import style0 from "./testMemberNavi.vue?vue&type=style&index=0&id=48eaf041&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eaf041",
  null
  
)

export default component.exports